import { Redirect, Route, useLocation } from 'react-router-dom';

import Accounting from '../views/Accounting/Accounting';
import { CashbackBonus } from '../views/CashbackBonus/CashbackBonus';
import { CookiePolicy } from '../views/CookiePolicy/CookiePolicy';
import { EarningsBackoffice } from '../views/Earnings/Earnings';
import { Question } from '../views/HelpDesk/Question';
import { SubCategory } from '../views/HelpDesk/Subcategory';
import MyTeamBackofficeRoot from '../views/MyTeamBackoffice/MyTeamBackofficeRoot';
import { Orders } from '../views/Orders/Orders';
import { Portfolio } from '../views/Portfolio/Portfolio';
import { PrivacyPolicy } from '../views/PrivacyPolicy/PrivacyPolicy';
import { RankingRoot } from '../views/Ranking/RankingRoot';
import { Resources } from '../views/Resources/Resources';
import { TermsOfUse } from '../views/TermsOfUse/TermsOfUse';

import { EventPromoCruises } from '../views/EventPromo/EventPromoCruises';

import Dashboard from '../views/Dashboard/Dashboard';

import { Marketplace } from '../views/Marketplace/Marketplace';

import { BackofficeLayout } from '../layout/BackofficeLayout/BackofficeLayout';
import { HelpDesk } from '../views/HelpDesk/HelpDesk';
// import { Gaming } from '../views/Marketplace/Gaming/Gaming';
import {
  ACCOUNTING,
  CASHBACK_BONUS,
  COOKIE_POLICY,
  DASHBOARD,
  EARNINGS,
  // GAMING,
  // PAYMENT,
  HELPDESK,
  HELPDESK_QUESTION,
  HELPDESK_SUBCATEGORY,
  MARKETPLACE,
  MY_HUBS,
  MY_TEAM,
  ORDERS,
  PRIVACY_POLICY,
  RANKING,
  RESOURCES,
  TERMS_OF_USE,
  CRUISES_PROMOTION,
  BANGKOK_PROMOTION,
  TRADING,
  DISCOUNT_CODE,
  SETTINGS_TEAM_SETTINGS,
  BIG_WHALE,
  AIRDROPS,
  // TRAVEL_PACKAGES,
  // FLIPME_CARDS,
  // FINUP_HUBS,
  SUPPORT_TICKETS,
  // POWERPACKS,
  // AKASHA,
  MANAGE_AKASHA_NODE
  // DUBAI_TOKEN_PROMOTION
} from './routes';
import { SettingsRoutes } from './settingsRoutes';
import { Payment } from '../views/Marketplace/Payment/Payment';

import { EventPromoBangkok } from '../views/EventPromo/EventPromoBangkok';

import { Trading } from '../views/Marketplace/Trading/Trading';
import { useAppSelector } from '../app/hooks';
import { UserTypes } from '../types/loginTypes';
// import { DiscountCode } from '../views/DiscountCode/DiscountCode';
import { BigWhale } from '../views/Marketplace/BigWhale/BigWhale';
import { Airdrops } from '../views/Airdrops/Airdrops';

import { FlipmeCards } from '../views/Marketplace/FlipmeCards/FlipmeCards';
import SupportTickets from '../views/SupportTickets/SupportTickets';
import { PowerPacks } from '../views/Marketplace/PowerPacks/PowerPacks';
import { Akasha } from '../views/Marketplace/Akasha/Akasha';

import { ManageAkashaNode } from '../views/Portfolio/ManageAkashaNode';
import { FinupMembership } from '../views/Marketplace/FinupMembership/FinupMembership';
// import { DubaiTokenPromo } from '../views/DubaiTokenPromo/DubaiTokenPromo';

export const BackofficeRoutes = () => {
  const { userInfo } = useAppSelector((state) => state.auth);

  const isRestrictedUser = userInfo.userType === UserTypes.Restricted;

  const location = useLocation();

  const pathname = location.pathname;

  const isRestrictedPath =
    isRestrictedUser &&
    (pathname === DASHBOARD ||
      pathname === MY_TEAM ||
      pathname === EARNINGS ||
      pathname === RANKING ||
      pathname === RESOURCES);

  const {
    isCanadaRestrictedUser,
    isJapanRestrictedUser,
    canBuyBigWhale,
    canBuyFlipMePackages,
    canBuyTravelPackages,
    canBuyStakingPackages,
    canBuyAkashaPackages,
    canBuyPowerPacksPackages,
    canBuyTradingPackages
  } = userInfo;

  const isCanadaRestrictedPath =
    isCanadaRestrictedUser &&
    (pathname === MARKETPLACE ||
      pathname === TRADING ||
      pathname === BIG_WHALE ||
      pathname === DISCOUNT_CODE ||
      pathname === RESOURCES ||
      pathname === CASHBACK_BONUS ||
      pathname === SETTINGS_TEAM_SETTINGS);

  // const isJapanRestrictedPath = !isJapanRestrictedUser && pathname === PAYMENT;

  const isHungaryRestrictedPath = !canBuyBigWhale && pathname === BIG_WHALE;

  // const isTradingPackegesRestrictedPath =
  //   !canBuyTradingPackages && pathname === FINUP_HUBS;

  // const isTravelPackegesRestrictedPath =
  //   !canBuyTravelPackages && pathname === TRAVEL_PACKAGES;

  // const isAkashaPackegesRestrictedPath =
  //   !canBuyAkashaPackages && pathname === AKASHA;

  // const isPowerPacksRestrictedPath =
  //   !canBuyPowerPacksPackages && pathname === POWERPACKS;

  // const isFlipmePackegesRestrictedPath =
  //   !canBuyFlipMePackages && pathname === FLIPME_CARDS;

  const isStakingPackegesRestrictedPath =
    !canBuyStakingPackages && pathname === MARKETPLACE;

  return (
    <BackofficeLayout>
      {isRestrictedPath && <Redirect to={MY_HUBS} />}
      {/* {isTravelPackegesRestrictedPath && <Redirect to={DASHBOARD} />} */}
      {/* {isTradingPackegesRestrictedPath && <Redirect to={DASHBOARD} />} */}
      {/* {isAkashaPackegesRestrictedPath && <Redirect to={DASHBOARD} />}
      {isPowerPacksRestrictedPath && <Redirect to={DASHBOARD} />} */}
      {isCanadaRestrictedPath && <Redirect to={DASHBOARD} />}
      {/* {isFlipmePackegesRestrictedPath && <Redirect to={DASHBOARD} />} */}
      {/* {isJapanRestrictedPath && <Redirect to={DASHBOARD} />} */}
      {isHungaryRestrictedPath && <Redirect to={DASHBOARD} />}
      {isStakingPackegesRestrictedPath && <Redirect to={DASHBOARD} />}

      <Route exact path={`${DASHBOARD}`} render={() => <Dashboard />} />

      <Route exact path={`${ORDERS}`} render={() => <Orders />} />

      <Route path={`${MY_HUBS}/:tab?`} render={() => <Portfolio />} />

      <Route
        path={`${MANAGE_AKASHA_NODE}/:id`}
        render={() => <ManageAkashaNode />}
      />

      <Route
        exact
        path={`${MY_TEAM}`}
        render={() => <MyTeamBackofficeRoot />}
      />

      <Route exact path={`${EARNINGS}`} render={() => <EarningsBackoffice />} />

      <Route exact path={`${RANKING}`} render={() => <RankingRoot />} />

      <Route exact path={`${RESOURCES}`} render={() => <Resources />} />

      <Route
        exact
        path={`${HELPDESK}/:categoryId?`}
        render={(props) => <HelpDesk {...props} />}
      />

      <Route
        exact
        path={`${HELPDESK_SUBCATEGORY}/:id?/:subId?`}
        render={(props) => <SubCategory {...props} />}
      />

      <Route
        exact
        path={`${HELPDESK_QUESTION}/:id?/:categoryId?/:subId?`}
        render={(props) => <Question {...props} />}
      />

      <Route exact path={`${ACCOUNTING}`} render={() => <Accounting />} />

      <Route
        exact
        path={`${CASHBACK_BONUS}`}
        render={() => <CashbackBonus />}
      />

      <Route exact path={`${TERMS_OF_USE}`} render={() => <TermsOfUse />} />

      <Route
        exact
        path={`${PRIVACY_POLICY}`}
        render={() => <PrivacyPolicy />}
      />

      <Route exact path={`${COOKIE_POLICY}`} render={() => <CookiePolicy />} />

      <Route exact path={`${AIRDROPS}`} render={(props) => <Airdrops />} />

      <Route
        exact
        path={`${CRUISES_PROMOTION}`}
        render={(props) => <EventPromoCruises />}
      />

      <Route
        exact
        path={`${BANGKOK_PROMOTION}`}
        render={(props) => <EventPromoBangkok />}
      />

      {/* <Route exact path={`${PAYMENT}`} render={() => <Payment />} /> */}

      {/* <Route exact path={`${POWERPACKS}`} render={() => <PowerPacks />} /> */}

      {/* <Route exact path={`${AKASHA}`} render={() => <Akasha />} /> */}

      {/* <Route exact path={`${FLIPME_CARDS}`} render={() => <FlipmeCards />} /> */}

      {/* <Route exact path={`${FINUP_HUBS}`} render={() => <FinupMembership />} /> */}

      <Route exact path={`${MARKETPLACE}`} render={() => <Marketplace />} />

      <Route
        exact
        path={`${SUPPORT_TICKETS}`}
        render={() => <SupportTickets />}
      />

      {canBuyBigWhale && (
        <Route exact path={`${BIG_WHALE}`} render={() => <BigWhale />} />
      )}

      {/* <Route
        exact
        path={`${DUBAI_TOKEN_PROMOTION}`}
        render={() => <DubaiTokenPromo />}
      /> */}

      <Route
        exact
        path={'/backoffice/settings/:path?'}
        render={() => (
          <SettingsRoutes isCanadaRestrictedUser={isCanadaRestrictedUser} />
        )}
      />
    </BackofficeLayout>
  );
};
